import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetGateEntryListMutation } from "../../../../store/api/gateEntryApiNew";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from '../../../../Core/Export/ExportCSV';
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";

const GateEntryComp = () => {
    const navigate = useNavigate();
	const { screenHeight, screenScaling , pageSize } = useScreenHeight();

    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [entryData, setEntryData] = useState({ gate_entries: [], total_no_of_records: 0 });
    const [gateentryDataApi] = useGetGateEntryListMutation();
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [deleteDoc] = useDeleteDocMutation();
    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false)
    const [delDone, setDelDone] = useState(false)

    const filtersConfig = [
        { name: 'siNo', label: 'S. No.', type: 'number' },
        { name: 'name', label: 'Gate Entry Id', type: 'text' },
        { name: 'creation', label: 'Creation Date', type: 'date' },
        { name: 'modified', label: 'Modified Date', type: 'date' },
        { name: 'modified_by', label: 'Modified By', type: 'text' },
        { name: 'grn_no', label: 'GRN No.', type: 'text' },
        { name: 'asn_no', label: 'ASN No.', type: 'text' },
        {
            name: 'select_transaction_type',
            label: 'Transaction Type',
            type: 'select',
            multiSelect: true,
            options: [
                { label: 'Purchase Order', value: 'Purchase Order' },
                { label: 'Sales Return', value: 'Sale Return' },
                { label: 'Outbound', value: 'Outbound' },
            ],
        },
        { name: 'select_trasnsation_no', label: 'Transaction No', type: 'text' },
        { name: 'eway_bill', label: 'E-Way Bill', type: 'text' },
        { name: 'invoice_no', label: 'Invoice No.', type: 'text' },
        { name: 'builty_no', label: 'Builty No.', type: 'text' },
        { name: 'invoice_value', label: 'Invoice Value', type: 'number' },
        { name: 'invoice_date', label: 'Invoice Date', type: 'date' },
        { name: 'total_invoice_qty', label: 'Total Invoice Qty', type: 'number' },
        { name: 'no_of_box', label: 'No. of Boxes', type: 'number' },
        { name: 'vehicle_no', label: 'Vehicle No.', type: 'text' },
        { name: 'select_vehicle', label: 'Vehicle Type', type: 'text' },
        {
            name: 'transport_method',
            label: 'Transport Method',
            type: 'select',
            options: [
                { value: 'road', label: 'Road' },
                { value: 'rail', label: 'Rail' },
                { value: 'air', label: 'Air' },
                { value: 'water', label: 'Water' },
            ],
        },
        { name: 'transporter', label: 'Transporter', type: 'text' },
        { name: 'vehicle_arrival_date', label: 'Arrival Date', type: 'date' },
        { name: 'vehicle_arrival_time', label: 'Arrival Time', type: 'time' },
        { name: 'driver_name', label: 'Driver Name', type: 'text' },
        { name: 'driver_mobile_no', label: 'Driver Mobile', type: 'text' },
        { name: 'sh_weight', label: 'SH Weight', type: 'number' },
        { name: 'vendor_name', label: 'Vendor Name', type: 'text' },
        { name: 'total_no_boxes', label: 'Total No. of Boxes', type: 'number' },
    ];


    const [columnsConfig, setColumnsConfig] = useState(() => [
        {
            header: "S. No.",
            name: "S. No.",
            accessor: "siNo",
            width: '7%',
            cellRenderer: (row) => row.siNo,
            sortable: false,
            visible: true
        },
        {
            header: "Gate Entry Id",
            name: "Gate Entry Id",
            accessor: "name",
            width: '15.7%',
            sortable: true,
            visible: true
        },
        {
            header: "Creation Date",
            name: "Creation Date",
            accessor: "creation",
            width: '12%',
            sortable: true,
            visible: false
        },
        {
            header: "Modified Date",
            name: "Modified Date",
            accessor: "modified",
            width: '12%',
            sortable: true,
            visible: false
        },
        {
            header: "Modified By",
            name: "Modified By",
            accessor: "modified_by",
            width: '12%',
            sortable: false,
            visible: false
        },
        {
            header: "GRN No.",
            name: "GRN No.",
            accessor: "grn_no",
            width: '13.7%',
            sortable: true,
            visible: true
        },
        {
            header: "ASN No.",
            name: "ASN No.",
            accessor: "asn_no",
            width: '13.7%',
            sortable: true,
            visible: true
        },
        {
            header: "Transaction Type",
            name: "Transaction Type",
            accessor: "select_transaction_type",
            width: '10.7%',
            sortable: true,
            visible: true
        },
        {
            header: "Transaction No",
            name: "Transaction No",
            accessor: "select_trasnsation_no",
            width: '10%',
            sortable: true,
            visible: true
        },
        {
            header: "E-Way Bill",
            name: "E-Way Bill",
            accessor: "eway_bill",
            width: '10%',
            sortable: false,
            visible: false
        },
        {
            header: "Invoice No.",
            name: "Invoice No.",
            accessor: "invoice_no",
            width: '13.7%',
            sortable: true,
            visible: false
        },
        {
            header: "Builty No.",
            name: "Builty No.",
            accessor: "builty_no",
            width: '10%',
            sortable: false,
            visible: false
        },
        {
            header: "Invoice Value",
            name: "Invoice Value",
            accessor: "invoice_value",
            width: '10%',
            sortable: true,
            visible: false
        },
        {
            header: "Invoice Date",
            name: "Invoice Date",
            accessor: "invoice_date",
            width: '10%',
            sortable: true,
            visible: false
        },
        {
            header: "Total Invoice Qty",
            name: "Total Invoice Qty",
            accessor: "total_invoice_qty",
            width: '10%',
            sortable: true,
            visible: false
        },

        {
            header: "No. of Boxes",
            name: "No. of Boxes",
            accessor: "no_of_box",
            width: '10%',
            sortable: true,
            visible: false
        },
        {
            header: "Vehicle No.",
            name: "Vehicle No.",
            accessor: "vehicle_no",
            width: '10%',
            sortable: true,
            visible: false
        },
        {
            header: "Vehicle Type",
            name: "Vehicle Type",
            accessor: "select_vehicle",
            width: '10%',
            sortable: false,
            visible: false
        },
        {
            header: "Transport Method",
            name: "Transport Method",
            accessor: "transport_method",
            width: '10%',
            sortable: false,
            visible: false
        },
        {
            header: "Transporter",
            name: "Transporter",
            accessor: "transporter",
            width: '12%',
            sortable: false,
            visible: false
        },
        {
            header: "Arrival Date",
            name: "Arrival Date",
            accessor: "vehicle_arrival_date",
            width: '10%',
            sortable: true,
            visible: false
        },
        {
            header: "Arrival Time",
            name: "Arrival Time",
            accessor: "vehicle_arrival_time",
            width: '10%',
            sortable: false,
            visible: false
        },
        {
            header: "Driver Name",
            name: "Driver Name",
            accessor: "driver_name",
            width: '10%',
            sortable: false,
            visible: true
        },
        {
            header: "Driver Mobile",
            name: "Driver Mobile",
            accessor: "driver_mobile_no",
            width: '12%',
            sortable: false,
            visible: false
        },

        {
            header: "SH Weight",
            name: "SH Weight",
            accessor: "sh_weight",
            width: '8%',
            sortable: true,
            visible: false
        },
        {
            header: "Vendor Name",
            name: "Vendor Name",
            accessor: "vendor_name",
            width: '12%',
            sortable: true,
            visible: false
        },
        {
            header: "Total No. of Boxes",
            name: "Total No. of Boxes",
            accessor: "total_no_boxes",
            width: '10%',
            sortable: true,
            visible: false
        },
        {
            header: "Action",
            name: "Action",
            width: '10%',
            sortable: false,
            accessor: "action",
            visible: true,
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.id}
                    onView={() => handleView(row.name)}
                    onEdit={() => handleEdit(row.name)}
                    onDelete={() => handleDelete(row.name)}
                />
            )
        }
    ]);

    // Handle column configuration changes
    const handleSaveColumns = (selectedKeys, allFields) => {
        const updatedColumns = columnsConfig.map(column => {
            return {
                ...column,
                visible: selectedKeys.includes(column.accessor)
            };
        });
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible === true),
        [columnsConfig]
    );

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible === true)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            }))
            .filter(col => col.fieldname),
        [columnsConfig]
    );

    const handleView = (id) => {
        try {
            navigate(`/inbound/gate-entry/view-gate-entry`, { state: { gate_id: id } });
        } catch (err) {
            console.error("View failed:", err);
        }
    };

    const handleEdit = async (id) => {
        try {
            console.log("check id is here or not", id);
            navigate(`/inbound/gate-entry/edit-gate-entry/`, { state: { gate_id: id } });
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };

    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true)
        setAlreadySubmitData(false)
        setDelmessage("Are you sure you want to Delete this Gate Entry?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    }

    const delHandleConfirm = async () => {
        
        try {
            await deleteDoc({ doctype: "Gate Entry", name: delSelectedId }).unwrap()
            setDelmessage(`Gate Entry ${delSelectedId} deleted successfully!`)
            setDelDone(true)
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelSelectedId(null);
                setDelDone(false)
                getData();
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the Gate Entry!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.split('You must')[0].trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);
    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
            className: "custom-btn-00989 d-flex",
            to: "/inbound/gate-entry/create-gate-entry",
            iconName: "FiPlus",
            style: { gap: '2px', height: '28px' },
            children: "Add Gate Entry"
        }
    ];

    const getData = async () => {
			setLoading(true);
			try {
				const filteredSearchInput = Object.entries(filters).reduce(
					(acc, [key, value]) => {
						if (value !== "" && value !== undefined && value !== null) {
							acc[key] = value;
						}
						return acc;
					},
					{}
				);
				const siNoFilter = filteredSearchInput.siNo;
				const isSiNoFilterActive =
					siNoFilter !== undefined && siNoFilter !== "";
				// STEP 3: If filtering by siNo, jump to that page
				const targetPage = isSiNoFilterActive
					? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
					: currentPage;
				const payload = {
					start: pageSize * (targetPage - 1),
					page_length: pageSize,
					...(Object.keys(filteredSearchInput).length > 0 && {
						search_input: {
							id: filteredSearchInput.id || "",
							name: filteredSearchInput.name || "",
							creation: filteredSearchInput.creation || "",
							modified: filteredSearchInput.modified || "",
							modified_by: filteredSearchInput.modified_by || "",
							grn_no: filteredSearchInput.grn_no || "",
							asn_no: filteredSearchInput.asn_no || "",
							select_transaction_type:
								filteredSearchInput.select_transaction_type || [],
							select_trasnsation_no:
								filteredSearchInput.select_trasnsation_no || "",
							eway_bill: filteredSearchInput.eway_bill || "",
							invoice_no: filteredSearchInput.invoice_no || "",
							builty_no: filteredSearchInput.builty_no || "",
							invoice_value: filteredSearchInput.invoice_value || "",
							invoice_date: filteredSearchInput.invoice_date || "",
							total_invoice_qty: filteredSearchInput.total_invoice_qty || "",
							no_of_box: filteredSearchInput.no_of_box || "",
							vehicle_no: filteredSearchInput.vehicle_no || "",
							select_vehicle: filteredSearchInput.select_vehicle || "",
							transport_method: filteredSearchInput.transport_method || "",
							transporter: filteredSearchInput.transporter || "",
							vehicle_arrival_date:
								filteredSearchInput.vehicle_arrival_date || "",
							vehicle_arrival_time:
								filteredSearchInput.vehicle_arrival_time || "",
							driver_name: filteredSearchInput.driver_name || "",
							driver_mobile_no: filteredSearchInput.driver_mobile_no || "",
							sh_weight: filteredSearchInput.sh_weight || "",
							vendor_name: filteredSearchInput.vendor_name || "",
							total_no_boxes: filteredSearchInput.total_no_boxes || "",
						},
					}),
				};

				const response = await gateentryDataApi(payload);
				const rawData = response.data.data.gate_entries;
				// STEP 4: Assign global serial numbers
				const numberedData = rawData.map((item, index) => ({
					...item,
					siNo: index + 1 + pageSize * (targetPage - 1),
				}));

				// STEP 5: If siNo is used, filter client-side
				const finalData = isSiNoFilterActive
					? numberedData.filter(
							(item) => item.siNo === parseInt(siNoFilter, 10)
					  )
					: numberedData;
				setEntryData({
					gate_entries: finalData,
					total_no_of_records: response.data.data.total_no_of_records,
				});

				// Optional: update currentPage to reflect jump
				if (isSiNoFilterActive) setCurrentPage(targetPage);
			} catch (error) {
				console.error("Error fetching gate entries:", error);
			} finally {
				setLoading(false);
			}
		};

		const handleFilterChange = (newFilters) => {
			setCurrentPage(1);
			setFilters(newFilters);
		};
        useEffect(() => {
			if (pageSize > 0) getData();
		}, [currentPage, filters, pageSize,screenHeight, screenScaling]);

    const accessors = columnsConfig
			.filter(
				(column) => column.accessor !== "siNo" && column.accessor !== "action"
			)
			.map((column) => column.accessor);
    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Inbound" },
                    { label: "Gate Entry List", style: { color: '#270B79' } }
                ]}
                actionButtons={actionButtons}
            >
                {showFilters && (
                    <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                )}

                {showColumnConfig && (
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Gate Entry"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "name", "action", "date"]}
                    />
                )}

                <Table
                    columns={visibleColumns}
                    data={entryData.gate_entries}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={entryData.total_no_of_records}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {delPopupVisible && <DelConfirmPopup
                        alredysubmitdata={alreadySubmitData}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                />}
                {showExportPopup && (
                    <ExportCSV
                        doctype="Gate Entry"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
            </ListLayout>
        </div>
    );
};

export default GateEntryComp;